class ConfirmSupervisorController {
  /*@ngInject*/
  constructor($translate, ScanService, Modal, $scope, User) {
    this.$translate = $translate
    this.ScanService = ScanService
    this.Modal = Modal
    this.model = {
      id: '',
      password: '',
      branchId: User.getUser().branchId
    };
    this.errorMessage = null;
    this.loading = false;
  }
  focusElementById(id) {
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 300)
  }
  $onInit() {
    this.focusElementById('sup-id');
  }
  confirmSupervisor() {
    if (this.loading) {
      return;
    }
    this.errorMessage = null;
    if (!this.model.id) {
      this.errorMessage = this.$translate.instant('confirmSupervisorModal.idMissing');
      this.focusElementById('sup-id');
      return;
    }
    if (!this.model.password) {
      this.errorMessage = this.$translate.instant('confirmSupervisorModal.passwordMissing');
      this.focusElementById('sup-password');
      return;
    }
    this.loading = true;
    this.ScanService.scanSupervisor(this.model.id, this.model.password, this.event, this.model.branchId, this.details)
      .then((data) => {
        if (data.error) {
          // this.loading = false;
          return this.Modal.errorModal(data.error);
          // return this.onError(data.error)
        }
        this.onConfirm(this.model.id.toString(), data, this.model.convertToPickup);
      })
      .catch((err) => {
        // this.focusElementById('sup-password');
        if (err && err.data && err.data.message) {
          this.loading = false;
          return this.Modal.errorModal(err.data.message);
        }
        else {
          return this.onError(err)
        }
      })
  }

}
export default ConfirmSupervisorController;


// WEBPACK FOOTER //
// ./client/app/common/ui/confirmSupervisor/confirmSupervisor.controller.js